import type { Constructor, LitMixinBase } from './mixin-types';
import { property } from 'lit/decorators.js';
import { UserProfile } from '../datatypes/user-profile';
import { consume } from '@lit/context';
import { UserProfileContext } from '../contexts/user-profile-context';

export const WithUserProfileConsumer = <T extends LitMixinBase>(
  superClass: T
) => {
  class WithUserProfileConsumerClass extends superClass {
    @consume({ context: UserProfileContext, subscribe: true })
    @property({ attribute: false })
    public userProfile?: UserProfile;
    updated(changedProperties: Map<string | number | symbol, unknown>): void {
      if (changedProperties.has('userProfile')) {
        this.doUserProfileChanged();
      }
    }
    doUserProfileChanged() {
      console.log('doUserProfileChanged');
    }
  }

  return WithUserProfileConsumerClass as Constructor<WithUserProfileConsumerInterface> &
    T;
};

export interface WithUserProfileConsumerInterface {
  userProfile?: UserProfile;
}
